import {Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'brover-search',
    templateUrl: './search.component.html',
    standalone: false
})
export class SearchComponent implements OnInit {
  @HostBinding('class.brover-search') hostClass = true;
  @ViewChild('input') input: ElementRef;

  // tslint:disable-next-line:no-output-rename
  @Output('valueChange') valueChange = new EventEmitter<string>();

  // tslint:disable-next-line:no-input-rename
  @Input('placeholder') public placeholder = 'Zoeken';
  public value = '';

  ngOnInit() {
    if (this.input) {
      this.input.nativeElement.focus();
    }
  }

  search() {
    this.valueChange.next(this.value);
  }
}
